import { AlertDialog, Button, useControllableState } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface RevokeTokenDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export const RevokeTokenDialog = ({
  open,
  onOpenChange,
  onConfirm,
}: RevokeTokenDialogProps): JSX.Element => {
  const [isOpenState, setIsOpenState] = useControllableState({
    prop: open,
    defaultProp: false,
    onChange: onOpenChange,
  })

  return (
    <AlertDialog open={isOpenState} onOpenChange={setIsOpenState}>
      <AlertDialog.Content>
        <AlertDialog.Title>Revoke API Key</AlertDialog.Title>
        <AlertDialog.Description>
          Are you sure you want to revoke your API key? Any applications or
          scripts using this key will immediately stop working. This action
          cannot be undone.
        </AlertDialog.Description>

        <AlertDialog.Actions>
          <AlertDialog.Cancel>
            <Button variant="tertiary">Cancel</Button>
          </AlertDialog.Cancel>

          <Button variant="critical" onClick={onConfirm}>
            Revoke Key
          </Button>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
